(ns io.daskul.tutorial.webapp.shared.sentry
  "Sentry React SDK wrapper.

   Initializes Sentry for frontend error tracking with session replay.
   When DSN is nil, all functions are no-ops."
  (:require
   ["@sentry/react" :as sentry]))

(defn init!
  "Initialize Sentry with the given config map.
   No-op when :dsn is nil (local development).
   Optional :release sets the Sentry release (e.g. \"dev (bf6de51)\")."
  [{:keys [dsn environment release]}]
  (when dsn
    (sentry/init
     (clj->js (cond-> {:dsn dsn
                        :environment (or environment "production")
                        :integrations [(sentry/replayIntegration
                                                     #js {:maskAllText false
                                                          :blockAllMedia false})]
                        :replaysSessionSampleRate 0.1
                        :replaysOnErrorSampleRate 1.0}
                release (assoc :release release))))))

(defn set-user!
  "Set the current user context on Sentry.
   Called after login with decoded JWT claims."
  [user]
  (let [{:keys [id school-id branch-id role available-contexts]} user]
    (sentry/setUser
     (clj->js (cond-> {:id (str id)}
                school-id (assoc :school-id (str school-id))
                branch-id (assoc :branch-id (str branch-id))
                role (assoc :role (if (keyword? role) (name role) role))
                available-contexts (assoc :available-contexts
                                          (pr-str available-contexts)))))))

(defn clear-user!
  "Clear user context from Sentry. Called on logout."
  []
  (sentry/setUser nil))
